/**
 * Three-tier consent state machine.
 * Consent is stored in localStorage and synced with the backend.
 */

const CONSENT_KEY = 'astro_consent';

const defaultState = {
  tier1: false,
  tier2: false,
  timestamp: null,
};

export function getConsent() {
  try {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch {
    // Ignore parse errors
  }
  return { ...defaultState };
}

export function setConsent(consent) {
  const state = {
    tier1: Boolean(consent.tier1),
    tier2: Boolean(consent.tier2),
    timestamp: new Date().toISOString(),
  };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(state));
  return state;
}

export function withdrawConsent() {
  const state = { ...defaultState, timestamp: new Date().toISOString() };
  localStorage.setItem(CONSENT_KEY, JSON.stringify(state));
  return state;
}

export function hasConsent(tier) {
  // Consent temporarily bypassed — all tiers allowed without opt-in.
  // TODO: Re-enable consent gating once analytics is validated end-to-end.
  return true;
}
